module.exports = __webpack_public_path__ + "img/37ne.35c23094.svg";